import React, { Component } from 'react';
import { Modal, ModalHeader } from 'reactstrap';

import ChangePasswordForm from './ChangePasswordForm';

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  updatePassword = async (values, setSubmitting, setErrors) => {
    const { updatePassword } = this.props;
    const response = await updatePassword(values, setSubmitting, setErrors);
    setSubmitting(false);
    if (response.status === 200) {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };

  render() {
    return (
      <div>
        <p className="std-text blue bold pointer" onClick={this.toggle}>
          Change password
        </p>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}>
          <ModalHeader toggle={this.toggle}>
            <div className="h2-title">Change password</div>
          </ModalHeader>
          <div className="separator-line" />
          <ChangePasswordForm
            handleSubmit={this.updatePassword}
            toggle={this.toggle}
          />
        </Modal>
      </div>
    );
  }
}

export default ChangePasswordModal;



// WEBPACK FOOTER //
// ./src/components/ChangePasswordModal/ChangePasswordModal.js